import React, { Component, PropTypes } from 'react';
import { Col, ControlLabel, FormGroup } from 'react-bootstrap';

class Product extends Component {
  constructor(props) {
    super(props);
    this.state = {
      option: []
    }
  }

  render() {
    return (
      <FormGroup controlId="product">
        <Col componentClass={ControlLabel} sm={4}>
          Product
        </Col>
        <Col sm={8}>
              <select
                className="custom-select"
                onChange={this.props.handleChangeProduct}
                value={this.props.product}
                id="product"
              >
                <option value="">Please Select</option>
                <option value="pv">SmartDrive Private Car</option>
                <option value="cv">SmartDrive Commercial Vehicle</option>
              </select>
        </Col>
      </FormGroup>
    )
  }
}

Product.propTypes = {
  handleChangeProduct: PropTypes.func,
  product: PropTypes.string
};

export default Product;



// WEBPACK FOOTER //
// ./src/app/components/retrieveQuotationComponent/product/Product.js